// Layout: Form
// Disable Gravity Forms Orbital theme styling so our custom CSS takes full control
// + Floating labels, expanding textarea

(function() {
    function initForm(wrapper) {
        // Disable GF theme
        wrapper.classList.add('gform-theme__disable');
        wrapper.classList.remove('gform-theme--framework', 'gform-theme--orbital', 'gform-theme--foundation');
        wrapper.removeAttribute('data-form-theme');

        // Remove the inline <style> tag GF injects with theme variables
        var inlineStyle = wrapper.querySelector(':scope > style');
        if (inlineStyle) {
            inlineStyle.remove();
        }

        // --- Floating Labels ---
        var fields = wrapper.querySelectorAll('.gfield--type-text, .gfield--type-email, .gfield--type-phone, .gfield--type-textarea, .gfield--type-website, .gfield--type-number');

        fields.forEach(function(field) {
            var input = field.querySelector('input, textarea');
            if (!input) return;

            // Check initial value (e.g. browser autofill, pre-populated)
            if (input.value.trim() !== '') {
                field.classList.add('gfield--active');
            }

            input.addEventListener('focus', function() {
                field.classList.add('gfield--active');
            });

            input.addEventListener('blur', function() {
                if (input.value.trim() === '') {
                    field.classList.remove('gfield--active');
                }
            });

            // Catches typing even if focus event was missed after re-render
            input.addEventListener('input', function() {
                if (input.value.trim() !== '') {
                    field.classList.add('gfield--active');
                }
            });
        });

        // Re-check values after a frame — catches GF restoring values post-render
        requestAnimationFrame(function() {
            fields.forEach(function(field) {
                var input = field.querySelector('input, textarea');
                if (input && input.value.trim() !== '') {
                    field.classList.add('gfield--active');
                }
            });
        });

        // --- Expanding Textarea ---
        var textareaFields = wrapper.querySelectorAll('.gfield--type-textarea');

        textareaFields.forEach(function(field) {
            var textarea = field.querySelector('textarea');
            if (!textarea) return;

            textarea.addEventListener('focus', function() {
                field.classList.add('gfield--textarea-expanded');
            });

            textarea.addEventListener('blur', function() {
                if (textarea.value.trim() === '') {
                    field.classList.remove('gfield--textarea-expanded');
                }
            });
        });
    }

    function initAllForms() {
        var formWrappers = document.querySelectorAll('.form .gform_wrapper');
        formWrappers.forEach(initForm);
    }

    document.addEventListener('DOMContentLoaded', initAllForms);

    // Re-initialize after GF AJAX submissions (form re-render)
    // GF triggers this as a jQuery event, so we must use jQuery to listen
    jQuery(document).on('gform_post_render', function(event, formId) {
        if (formId) {
            var wrapper = document.querySelector('.form .gform_wrapper[data-form-id="' + formId + '"]') ||
                          document.querySelector('.form #gform_wrapper_' + formId);
            if (wrapper) {
                initForm(wrapper);
            }
        } else {
            initAllForms();
        }
    });
})();
